// extracted by mini-css-extract-plugin
module.exports = {"container":"_2FyqFdVRAc2XR7wrRwmZjG","inner":"b1f7Yo0nlDQtcG7y68oQt","description":"_3Mj2dMSCRElzMshDu9EJgy"};